// extracted by mini-css-extract-plugin
export default {"input":"TextInput_input__f43xN","input_focus":"TextInput_input_focus__yojJt","error":"TextInput_error__3GQpo","error_text":"TextInput_error_text__VQzNc"};